<template>
  <div>
    <h1>{{ $t("settings.users.userList") }}</h1>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
      </v-col>
      <v-spacer />
      <div>
        <v-btn
          :disabled="$store.getters['Ajax/loading']"
          @click="syncWithWnb"
          block
          color="primary"
          v-if="
            $store.getters['isWnbUser'] &&
              $store.getters['companyContext'] != null &&
              ($store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
                $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2)
          "
          >{{ $t("settings.users.syncUsersWithWNB") }}</v-btn
        >
      </div>
      <div v-if="!$store.getters['isWnbUser']">
        <v-btn block color="accent" :to="baseAddress + 'new'">{{ $t("settings.users.addNewUser") }}</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="users" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.surname }}</td>
          <td class="text-left">{{ props.item.login }}</td>
          <td class="text-left">{{ props.item.email }}</td>
          <td class="text-center">
            <v-tooltip bottom v-if="!$store.getters['isWnbUser']">
              {{ $t("settings.users.passwordReset.tooltip") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="passwordReset(props.item.id)" icon v-on="on">
                  <v-icon>fa-user-shield</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn v-on="on" :to="editAddress(props.item.id)" icon>
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "UsersList",
  data: () => ({
    search: "",
    users: []
  }),
  computed: {
    baseAddress() {
      return this.$store.getters["companyContext"] == null ? "/admin/users/" : "/settings/users/";
    },
    headers() {
      return [
        { text: this.$t("settings.users.fields.name.name"), value: "name" },
        {
          text: this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.downloadUsersList();
  },
  methods: {
    editAddress(userId) {
      return this.$store.getters["companyContext"] == null
        ? this.baseAddress + "edit/" + userId + "/basic"
        : this.baseAddress + "edit/" + userId + "/delegation";
    },
    passwordReset(userId) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.users.passwordReset.content"),
        title: this.$t("settings.users.passwordReset.title")
      });
      result.then(() => {
        this.axios.post("settings/user/password-reset", { userId: userId }).then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        });
      });
    },
    downloadUsersList() {
      this.axios.get("settings/user/list").then(resp => {
        this.users = resp.data;
      });
    },
    syncWithWnb() {
      this.axios.get("settings/user/sync-with-wnb").then(() => {
        this.downloadUsersList();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("settings.users.syncedUsers"),
          position: "down"
        });
      });
    }
  }
};
</script>

<style scoped></style>
